















































import { Component, Prop, Vue } from 'vue-property-decorator'
import ConfirmRemovalDialog from './ConfirmRemovalDialog.vue'

@Component({
  components: {
    ConfirmRemovalDialog,
  },
})
export default class RowActions extends Vue {
  @Prop({ required: true })
  public item!: object
  @Prop({ default: false })
  public canDuplicate!: boolean
  @Prop({ default: false })
  public canEditVersions!: boolean
  @Prop({ default: false })
  public canDownload!: boolean
  @Prop({ default: false })
  public canDownloadChangeLog!: boolean
  @Prop({ default: true })
  public deleteConfirmationRequired!: boolean

  public deleteConfirmationDialogShown: boolean = false

  public editItem(item) {
    this.$emit('editItem', item)
  }
  
  public initiateDeleteItem(item) {
    if (this.deleteConfirmationRequired) {
      this.deleteConfirmationDialogShown = true
    } else {
      this.deleteItem(item)
    }
  }

  public deleteItem(item) {
    this.$emit('deleteItem', item)
  }

  public duplicateItem(item) {
    this.$emit('duplicateItem', item)
  }

  public downloadItem(item) {
    this.$emit('downloadItem', item)
  }

  public downloadItemChangesLog(item) {
    this.$emit('downloadItemChangesLog', item)
  }

  public editItemVersions(item) {
    this.$emit('editItemVersions', item)
  }
}
